import { useState } from 'react'
import { FormControl } from 'baseui/form-control'
import { KIND, SIZE } from 'baseui/button'
import { Notification, KIND as NOTIFICATION_KIND } from 'baseui/notification'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDDatePicker from '@/shared/components/SDComponents/SDDatePicker'
import { Input } from 'baseui/input'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useSnackbar } from 'baseui/snackbar'

import { selectOrganizationsSelectedProvider } from '../organizationsManagementSelectors'
import { nettingUpdaterActions } from './nettingUpdaterSagas'
import { selectNettingUpdaterStoreData } from './nettingUpdaterSelectors'
import {
  ActionsRow,
  NotificationsWrapper,
  HeaderRow,
  ProviderInfo,
} from './styled-components'

const NettingFtpsForm = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation('organizationManagement')
  const navigate = useNavigate()
  const { enqueue } = useSnackbar()

  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)
  const { isSubmitting, resultError, resultMessage } = useSelector(selectNettingUpdaterStoreData)

  const [startDate, setStartDate] = useState(null)
  const [fileDate, setFileDate] = useState(null)
  const [limit, setLimit] = useState('')

  const providerName = selectedProvider?.name || ''

  const hasSuccessMessage = resultMessage && !resultError
  const hasErrorMessage = Boolean(resultError)

  const isValid = Boolean(startDate)

  const onSubmit = () => {
    dispatch({
      type: nettingUpdaterActions.SUBMIT_FTPS,
      enqueue,
      t,
      startDate,
      fileDate,
      limit: limit ? Number(limit) : null,
      providerId: selectedProvider?.id,
    })
  }

  const onGoBack = () => {
    navigate(-1)
  }

  return (
    <div>
      <HeaderRow>
        <SDButton
          onClick={onGoBack}
          size={SIZE.mini}
          kind={KIND.secondary}
        >
          {t('netting.button_back')}
        </SDButton>
      </HeaderRow>

      <ProviderInfo>
        {t('netting.provider_label')}: <strong>{providerName}</strong>
      </ProviderInfo>

      <FormControl label={t('netting.ftps.label_start_date')}>
        <SDDatePicker
          value={startDate ? [startDate] : []}
          onChange={({ date }) => setStartDate(Array.isArray(date) ? date[0] : date)}
          formatString="dd/MM/yyyy"
          placeholder={t('netting.ftps.placeholder_date')}
        />
      </FormControl>

      <FormControl
        label={t('netting.ftps.label_file_date')}
        caption={t('netting.ftps.caption_file_date')}
      >
        <SDDatePicker
          value={fileDate ? [fileDate] : []}
          onChange={({ date }) => setFileDate(Array.isArray(date) ? date[0] : date)}
          formatString="dd/MM/yyyy"
          placeholder={t('netting.ftps.placeholder_date')}
        />
      </FormControl>

      <FormControl
        label={t('netting.ftps.label_limit')}
        caption={t('netting.ftps.caption_limit')}
      >
        <Input
          value={limit}
          onChange={e => setLimit(e.target.value.replace(/\D/g, ''))}
          type="number"
          min={1}
          placeholder={t('netting.ftps.placeholder_limit')}
        />
      </FormControl>

      <ActionsRow>
        <SDButton
          onClick={onSubmit}
          isLoading={isSubmitting}
          disabled={!isValid || isSubmitting}
          size={SIZE.compact}
        >
          {t('netting.ftps.button_submit')}
        </SDButton>
      </ActionsRow>

      {hasSuccessMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.positive}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(resultMessage)}
          </Notification>
        </NotificationsWrapper>
      )}

      {hasErrorMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.negative}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(resultError)}
          </Notification>
        </NotificationsWrapper>
      )}
    </div>
  )
}

export default NettingFtpsForm
